export default function ContactSection() {
  return (
    <section id="contact" className="relative py-16 md:py-20 bg-background-50">
      <div className="w-full px-4 md:px-6 max-w-[1400px] mx-auto">
        <div className="relative rounded-2xl overflow-hidden bg-gradient-to-br from-background-900 to-background-800 border border-background-200/60">
          <div className="absolute top-0 right-0 w-[300px] h-[300px] bg-primary-500/5 rounded-full blur-3xl"></div>
          <div className="relative z-10 p-8 md:p-12 text-center">
            <div className="inline-flex items-center gap-2 px-3 py-1 rounded-full bg-accent-500/10 border border-accent-500/20 mb-4">
              <i className="ri-mail-send-line text-accent-400 text-xs"></i>
              <span className="text-accent-300 text-xs font-medium">联系我们</span>
            </div>
            <h2 className="font-heading text-2xl md:text-3xl lg:text-4xl font-bold text-background-50">
              剧迷互动 · 意见反馈
            </h2>
            <p className="mt-3 text-sm md:text-base text-foreground-300 max-w-lg mx-auto leading-relaxed">
              如果您有想看的剧集推荐、使用体验反馈或任何合作意向，欢迎通过以下方式与我们联系。6080新视觉影视始终倾听每一位剧迷的声音，持续优化您的追剧体验。
            </p>
            <div className="mt-8 flex flex-col sm:flex-row items-center justify-center gap-4">
              <div className="flex items-center gap-3 px-6 py-3.5 rounded-xl bg-background-700/50 border border-background-600/50 cursor-pointer hover:bg-background-700 transition-colors">
                <i className="ri-mail-line text-primary-400 text-xl"></i>
                <div className="text-left">
                  <div className="text-xs text-foreground-400">电子邮箱</div>
                  <div className="text-sm text-background-50 font-medium">feedback@6080tv.com</div>
                </div>
              </div>
              <div className="flex items-center gap-3 px-6 py-3.5 rounded-xl bg-background-700/50 border border-background-600/50 cursor-pointer hover:bg-background-700 transition-colors">
                <i className="ri-wechat-line text-accent-400 text-xl"></i>
                <div className="text-left">
                  <div className="text-xs text-foreground-400">微信公众号</div>
                  <div className="text-sm text-background-50 font-medium">6080新视觉影视</div>
                </div>
              </div>
              <div className="flex items-center gap-3 px-6 py-3.5 rounded-xl bg-background-700/50 border border-background-600/50 cursor-pointer hover:bg-background-700 transition-colors">
                <i className="ri-message-3-line text-secondary-400 text-xl"></i>
                <div className="text-left">
                  <div className="text-xs text-foreground-400">剧集推荐</div>
                  <div className="text-sm text-background-50 font-medium">提交想看的剧</div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}